import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';

import { Form } from 'common/components';

const AssetsEdit = ({ assetId, companyId, subcompanyId, t }) => (
  <Form.Link
    className="btn btn-sm btn-outline-primary w-100 my-1"
    to={createRoute(companyId, subcompanyId, `assets/${assetId}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

AssetsEdit.propTypes = {
  assetId: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  subcompanyId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(AssetsEdit);



// WEBPACK FOOTER //
// src/components/assets/actions/AssetsEdit.js